import React from "react";

import { useTranslation } from "@tecma/i18n";
import { Icon } from "@tecma/ds";

import { Building } from "types/rooms";

import "./apartment-info.scss";
import { normalizeText } from "utils/NormalazeData";

interface ApartmentInfoProps {
  name: string;
  model: string;
  building: Building;
}

const ApartmentInfo: React.FC<ApartmentInfoProps> = ({
  name,
  model,
  building,
}) => {
  const { t } = useTranslation();

  return (
    <div className='apartment-info'>
      <div className='apartment-location'>
        {building?.zone && (
          <>
            <div className='zone'>{building.zone}</div>
            <Icon iconName='dot' filled size='extra-small' />
          </>
        )}
        <div className='address'>{building?.address}</div>
      </div>
      <h2 className='apartment-name'>
        {t(`apartment-model.${model}`, {
          defaultValue: normalizeText(model),
        })}
        <span>{name}</span>
      </h2>
    </div>
  );
};

export default React.memo(ApartmentInfo);
